import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    getCollaborators(_, { uuid_branch } = {}) {
      return axios({
        url: `${process.env.VUE_APP_URL}/visits/unauthenticated/${uuid_branch}/hosts`,
        method: 'GET',
      })
    },
    createCustomHost(_, { uuid_branch, data } = {}) {
      return axios({
        url: `${process.env.VUE_APP_URL}/visits/unauthenticated/${uuid_branch}/host`,
        method: 'POST',
        data,
      })
    },
    generateQr(_, { uuid_branch, data } = {}) {
      return axios({
        url: `${process.env.VUE_APP_URL}/visits/unauthenticated/${uuid_branch}/`,
        method: 'POST',
        data,
      })
    },
  }
}